__turbopack_context__.v({
  "Copied": "Share-module-scss-module__zejb7G__Copied",
  "IsBottom": "Share-module-scss-module__zejb7G__IsBottom",
  "Items": "Share-module-scss-module__zejb7G__Items",
  "Title": "Share-module-scss-module__zejb7G__Title",
  "showCopied": "Share-module-scss-module__zejb7G__showCopied",
});
